export const bearerTokenStorageKey = "trybacon.ai-auth.access";
export const refreshTokenStorageKey = "trybacon.ai-auth.refresh";
export const sidebarModeStorageKey = "trybacon.ai-app.sidebar-mode";
export const walkthroughStorageKey = "trybacon.ai-app.walkthrough";

export const isLocal = import.meta.env.VITE_ENV === "local";
export const isDevelopment = import.meta.env.VITE_ENV === "development";
export const isProduction = import.meta.env.VITE_ENV === "production";
